
import Vue from "vue";
import Template from "@/assets/js/template.js";
const demoTemplate = require("@/assets/data/demoTemplate.json") 
const demoPreview = require("@/assets/data/demoPreview.json") 
export default {
    setToken(state, token) {
      // console.log("setting new token");
      localStorage.setItem("token", JSON.stringify(token));
      state.token = token;
    },
    clearEditorState({ state }) {
      this.state.sentenceBeingEdited = null;
      this.state.templateDataSearchResults = [];
      this.state.currentDatasetId = null;
    },
    addFileName(state, { template }) {},
    addSentenceToTemplate(state, { templateName, variable }) {
      if (!variable || !templateName) {
        return;
      }
      const template = state.template[templateName];
      // console.log(`template: ${JSON.stringify(template, null, 2)}`);
      let sentence = {
        texts: [],
        number: 1,
        priority: 1,
        conditions: [
          {
            expression: "",
          },
        ],
      };
      sentence.texts.push(`${variable.name}`);
      template[templateName].push(sentence);
      // console.log(`section: ${template[templateName]}`);
      Vue.set(state, "template", template);
    },
    addTemplateVariable(state, { variable }) {
      const templateVars = state.templateVariables;
      if (variable) {
        templateVars.push(variable);
      }
      // console.log(`template variables: ${JSON.stringify(templateVars, null, 2)}`);
      Vue.set(state, "templateVariables", templateVars);
    },
    setVariantBeingEdited(state, variant) {
      if (state.variantBeingEdited && state.variantBeingEdited != variant) {
        state.variantBeingEdited.stopEditing();
      }
      state.variantBeingEdited = variant;
      variant.edit();
    },
    blockSentencePreviewPopover(state) {
      Vue.set(state, "sentencePreviewPopoverIsBlocked", true);
    },
    setSentenceBeingEdited(state, sentence) {
      Vue.set(state, "scrollToPath", true);
      Vue.set(state, "sentenceBeingEdited", sentence);
    },
    setSentenceEditorPreview(state, preview) {
      Vue.set(state, "sentenceEditorPreview", preview);
    },
    setActiveTextEditor(state, editor) {
      Vue.set(state, "activeTextEditor", editor);
    },
    setTemplateSectionBeingEdited(state, section) {
      Vue.set(state, "templateSectionBeingEdited", section);
    },
    setTemplateSectionBeingNamed(state, sectionName) {
      Vue.set(state, "templateSectionBeingNamed", sectionName);
    },
    setTemplateSectionBeingNamedAndID(state, sectionId) {
      Vue.set(state, "templateSectionBeingNamedAndID", sectionId);
    },
    setExclusiveDropdown(state, dropdown) {
      Vue.set(state, "exclusiveDropdown", dropdown);
    },
    toggleScrollToPath(state) {
      Vue.set(state, "scrollToPath", !state.scrollToPath);
    },
    renameTemplateSynonym(state, data) {
      const index = state.template.globalSynonyms.findIndex((s) => s.name == data.synonymName);
      Vue.set(state.template.globalSynonyms[index], "name", data.newName);
    },
    replaceTextByRegex(state, data) {
      state.template.replaceByRegex(data.query, data.replacement, data.pattern);
    },
    replaceVariablesInConditions(state, data) {
      state.template.replaceInAllConditions(data.query, data.replacement, data.pattern);
    },
    replaceTextByRegexInCurrentSection(state, data) {
      state.templateSectionBeingEdited.replaceByRegex(data.query, data.replacement, data.pattern);
    },
    transformTemplateSynonyms(state, data) {
      state.template.transformTemplateSyn(data.synonym, data.pattern);
    },
    transformTemplateSynonymsInCurrentSection(state, data) {
      state.templateSectionBeingEdited.transformTemplateSyn(data.synonym, data.pattern);
    },

    // setActiveTextEditorContents(state, { editor, sentences }) {
    //     sentences.forEach(sentence => {
    //         sentence = new SentencePreview(sentence, this.sectionId)
    //         if (!sentence.sentences) {
    //             contents.push({ insert: sentence.text })
    //         } else {
    //             contents.push({ insert: { sentence: sentence } })
    //         }
    //     })
    //     console.log(`newly entered text: ${newlyEnteredText}`)
    //     editor.setContents(contents)
    //     // Vue.set(state, 'activeTextEditor', editor)
    // },
    setTemplateData(state, { template, variables }) {
      // todo: new Template(template)
      Vue.set(state, "template", new Template(template));
      Vue.set(state, "templateVariables", variables);
      this.unsavedChanges = false;
    },
    unblockSentencePreviewPopover(state) {
      Vue.set(state, "sentencePreviewPopoverIsBlocked", false);
    },
    setSelectedDataset(state, { selectedDataset }) {
      Vue.set(state, "selectedDataset", selectedDataset);
    },
    toggleShowTooltips(state) {
      Vue.set(state, "showTooltips", !state.showTooltips);
      localStorage.setItem("toggleShowTooltips", state.showTooltips);
    },

    //Drag n drop functionality

    dragVariant(state, data) {
      Vue.set(state, "draggedVariant", data.draggedVariant);
      Vue.set(state, "draggedVariantList", data.draggedVariantList);
      Vue.set(state, "sentenceDraggedFrom", data.sentenceDraggedFrom);
    },
    dropVariantInList(state, itemIndex) {
      // const updatedVariantList = state.draggedVariantList.variants.splice(itemIndex, 1);
      state.draggedVariantList.remove(state.draggedVariant);
      // Vue.set(state, "draggedVariantList", updatedVariantList);
    },
    dragVariantEnded(state) {
      Vue.set(state, "draggedVariant", null);
      Vue.set(state, "draggedVariantList", null);
      Vue.set(state, "sentenceDraggedFrom", null);
    },

    dragScenario(state, data) {
      Vue.set(state, "draggedScenario", data.draggedScenario);
      // Vue.set(state, "draggedSentencelist", data.draggedSentencelist);
      // Vue.set(state, "scenarioIndex", data.scenarioIndex);
    },

    dragScenarioEnded(state) {
      Vue.set(state, "draggedScenario", null);
      // Vue.set(state, "draggedSentencelist", null);
      // Vue.set(state, "scenarioIndex", null);
    },

    removeScenario(state, data) {
      state.templateSectionBeingEdited.findSentenceListById(data.sentenceListId).removeById(data.sentenceId);
    },

    addScenarioToNewList(state, data) {
      state.templateSectionBeingEdited.findSentenceListById(data.newSentenceListId).sentences.push(data.scenario);
      state.templateSectionBeingEdited.setPaths([]);
      Vue.set(state, "activePath", data.scenario.path);
    },

    refreshPathsInSection(state) {
      state.templateSectionBeingEdited.setPaths([]);
    },

    dragScenarioGroupStarted(state) {
      Vue.set(state, "draggingScenarioGroup", true);
    },

    dragScenarioGroupEnded(state) {
      Vue.set(state, "draggingScenarioGroup", false);
    },

    setTemplateSettings(state, templateData){
      const index = state.templates.findIndex(t => t.id == templateData.id)
      Vue.set(state.templates[index], "settings", templateData.settings)
    },
    
    updateUserInfo(state, userInfo) {
      Vue.set(state, "user", userInfo);
    },

    setTemplatePreview(state, preview){
      let newPreviewSections = [...state.templatePreview.sections]
      const templateSectionIDs = state.template.sections.map(s => s.id)
      preview.sections.forEach(s => {
        if(templateSectionIDs.includes(s.id)){
          const sectionIndex = newPreviewSections.findIndex(ps => ps.id == s.id)
          sectionIndex === -1 ? newPreviewSections.push(s) : newPreviewSections[sectionIndex] = s
        }
      })
      preview.sections = newPreviewSections
      Vue.set(state, "templatePreview", preview);
    },
    
    toggleTemplatePreviewAsHTML(state){
      Vue.set(state, "templatePreviewAsHTML", !state.templatePreviewAsHTML); 
    },
    
    addTemplate(state, template){
      state.templates.push(template)
    },
    
    showEditorDemoCTA(state, data){
      setTimeout(() => {
        Vue.set(state, "editorCtaContent", data);
        Vue.set(state, "showEditorCta", true);
      }, 20);
    },

    hideDemoCTA(state){
      Vue.set(state, "showEditorCta", false);
    },

    startDemoVersion(state){
      Vue.set(state, "editorIsDemoVersion", true); 
      // Vue.set(state, "startDemoVersion", true);      
    },

    setDummyTemplate(state){      
      Vue.set(state, "template", new Template(demoTemplate))
      Vue.set(state, "templateVariables", []);
      Vue.set(state, "templatePreview", demoPreview); 
    },

    saveDemoUserData(state, data){
      Vue.set(state, "demoData", data) 
      Vue.set(state, "template", new Template(data))
    },

    setTemporaryDemoKey(state, demoKey){
      Vue.set(state, "temporaryDemoKey", demoKey)
    },
    
    setTemporaryLoginEmail(state, email){
      Vue.set(state, "temporaryLoginEmail", email)
    },
    resetDemoState(state){
      Vue.set(state, "editorIsDemoVersion", false)
      Vue.set(state, "demoData", null)
      Vue.set(state, "temporaryDemoKey", null)
    },
    setPostDemoGuide(state, show){
      Vue.set(state, "postDemoGuide", show)
    },

    addPositionToDemoGuide(state, data){
      state.demoGuideSteps.push(data)
    },

    setDemoGuideCurrentStep(state, number){
      Vue.set(state, "demoGuideCurrentStep", number)
    },
    
    showDemoGuide(state, show){
      Vue.set(state, "showDemoGuide", show)
    },

    toggleKeyboardFocus(state, focus){
      Vue.set(state, "tabletKeyboardFocus", focus)
    },
    setTemplateVariables(state, variables){
      Vue.set(state, "templateVariables", variables)
    },
    setCurrentDatasetId(state, currentDatasetId){
      Vue.set(state, "currentDatasetId", currentDatasetId)
    },
    setDemoFavorites(state, dataList){
      Vue.set(state, "demoFavoriteList", dataList)
    },

    resetUserState(state){
      Vue.set(state, "user", null)
    },
    
    setAutoRephraseVariantAmount(state, amount){
      localStorage.setItem("preferred-ai-variant-rephrase-amount", amount);
      Vue.set(state, "autoRephraseVariantAmount", amount)
	},

    overwriteTemplateSection(state, section){
      let updatedSections = state.template.sections
      let updatedSectionIndex = updatedSections.findIndex(s => s.id == section.id)
      updatedSections[updatedSectionIndex] = section
      Vue.set(state.template, "sections", updatedSections)
    },
    aiSectionLoading(state, sectionId){
      Vue.set(state, "aiSectionPreviewError", [...state.aiSectionPreviewError.filter(e => e != sectionId)])
      Vue.set(state, "aiSectionsLoading", [...state.aiSectionsLoading, sectionId])
    },
    aiSectionLoaded(state, sectionId){
      Vue.set(state, "aiSectionsLoading", [...state.aiSectionsLoading.filter(e => e != sectionId)])
    },
    aiSectionPreviewError(state, sectionId){
      Vue.set(state, "aiSectionPreviewError", [...state.aiSectionPreviewError, sectionId])
    },
    
    setLoadingAiVariantStatus(state, status){
      Vue.set(state, "loadingAIVariants", status)
    },
    
    setAiTranslationLanguage(state, data){
      localStorage.setItem(`ai-translation-language-${data.templateId}`, data.language.toLowerCase());
      Vue.set(state, "aiTranslationLanguage", data.language.toLowerCase())
    }
  }